import { Spin } from "antd";
import React, {Suspense, lazy,startTransition } from "react";
import { createBrowserRouter } from "react-router-dom";
import { Navigate, useNavigate } from "react-router-dom";
import LandingPage from "../container/landingPage";
// import SingleBrandCategory from "../container/singleBrandcategory";
import MainLayout from "../container/layout";
import ForgotPassword from "../container/forgotPassword";
import Brands from "../container/landingPage/brands";
import Location from "../container/landingPage/location";
// import CarDetails from "../container/carDetails";
// import SellCar from "../container/sellCar";
// import BrandCategory from "../container/brandCategory";
// import FindMeBestCar from "../container/findYourCar";
// import FindYourCar from "../container/findYourCar";

// import Ads from "../container/myAds";
// import MyAds from "../container/myAds/ads";
// import SavedAds from "../container/myAds/savedAds";
// import Active from "../container/myAds/ads/active";
// import MyRides from "../container/myAds/myRides";
// import Pending from "../container/myAds/ads/pending";
// import Removed from "../container/myAds/ads/removed";
// import MyAlerts from "../container/myAds/myAlerts";
// import MyMessages from "../container/myAds/myMessages";
// import MyOrders from "../container/myAds/myOrders";
// import Payment from "../container/myAds/payment";

// import MyMessagesUser from "../container/myAds/myMessages/myMessagesUser";
// import Messages from "../container/myAds/myMessages";
// import Chat from "../container/myAds/myMessages/chat";
// import InActive from "../container/myAds/ads/inActive";
// import AdminLayout from "../container/admin/layout";
// import Users from "../container/admin/users/users";
// import Index from "../container/admin/users";
// import ActivePosts from "../container/admin/activePosts";
// import InActivePosts from "../container/admin/inActivePosts";
// import PendingPosts from "../container/admin/pendingPosts";
// import UserDetails from "../container/admin/users/userDetail";
// import LoginPage from "../container/login";
// import SignUpPage from "../container/signUp";
// import CompareCars from "../container/compare";
// import UpgradeAd from "../container/upgradeAd";
// import PaymentMethod from "../container/upgradeAd/paymentMethod";
// import PaymentForm from "../container/upgradeAd/paymentForm";
// import Bikes from "../container/bikes";
// import PrivacyPolicy from "../container/privacyPolicy";
// import DeleteDataPage from "../container/deleteData/deleteDataPage";
// import MyProfile from "../container/profile";
// import Add from "../container/admin/list";
// import List from "../container/admin/list";
// import Make from "../container/admin/list/make";
// import Model from "../container/admin/list/model";
// import Version from "../container/admin/list/version";
// const LandingPage = lazy(() => import("../container/landingPage"));
const SingleBrandCategory = lazy(() => import("../container/singleBrandcategory"));
// const MainLayout = lazy(() => import("../container/layout"));
const CarDetails = lazy(() => import("../container/carDetails"));
const SellCar = lazy(() => import("../container/sellCar"));
const BrandCategory = lazy(() => import("../container/brandCategory"));
const FindYourCar = lazy(() => import("../container/findYourCar"));
const Ads = lazy(() => import("../container/myAds"));
const MyAds = lazy(() => import("../container/myAds/ads"));
const SavedAds = lazy(() => import("../container/myAds/savedAds"));
const Active = lazy(() => import("../container/myAds/ads/active"));
const MyRides = lazy(() => import("../container/myAds/myRides"));
const Pending = lazy(() => import("../container/myAds/ads/pending"));
const Removed = lazy(() => import("../container/myAds/ads/removed"));
const MyAlerts = lazy(() => import("../container/myAds/myAlerts"));
const Messages = lazy(() => import("../container/myAds/myMessages"));
const MyMessagesUser = lazy(() => import("../container/myAds/myMessages/myMessagesUser"));
const Chat = lazy(() => import("../container/myAds/myMessages/chat"));
const InActive = lazy(() => import("../container/myAds/ads/inActive"));
const MyOrders = lazy(() => import("../container/myAds/myOrders"));
const Payment = lazy(() => import("../container/myAds/payment"));
const AdminLayout = lazy(() => import("../container/admin/layout"));
const Users = lazy(() => import("../container/admin/users/users"));
const ActivePosts = lazy(() => import("../container/admin/activePosts"));
const InActivePosts = lazy(() => import("../container/admin/inActivePosts"));
const PendingPosts = lazy(() => import("../container/admin/pendingPosts"));
const UserDetails = lazy(() => import("../container/admin/users/userDetail"));
const LoginPage = lazy(() => import("../container/login"));
// const ForgotPassword = lazy(() => import("../container/forgotPassword"));
// import ForgotPassword from "../container/forgotPassword";


const SignUpPage = lazy(() => import("../container/signUp"));
const CompareCars = lazy(() => import("../container/compare"));
const UpgradeAd = lazy(() => import("../container/upgradeAd"));
const PaymentMethod = lazy(() => import("../container/upgradeAd/paymentMethod"));
const PaymentForm = lazy(() => import("../container/upgradeAd/paymentForm"));
const Bikes = lazy(() => import("../container/bikes"));
const PrivacyPolicy = lazy(() => import("../container/privacyPolicy"));
const DeleteDataPage = lazy(() => import("../container/deleteData/deleteDataPage"));
const MyProfile = lazy(() => import("../container/profile"));
const List = lazy(() => import("../container/admin/list"));
const Make = lazy(() => import("../container/admin/list/make"));
const Model = lazy(() => import("../container/admin/list/model"));
const Version = lazy(() => import("../container/admin/list/version"));
const Index = lazy(() => import("../container/admin/users"));
// Lazy Loading Fallback Loader
const LazyLoader = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <Spin size="large" className="custom-spin"/>
  </div>
);

const role = localStorage.getItem("role");
// const Navigate = ({ to }) => {
//   const navigate = useNavigate();
//   React.useEffect(() => {
//     startTransition(() => {
//       navigate(to, { replace: true });
//     });
//   }, [to, navigate]);
//   return null;
// };

const router = createBrowserRouter([
  {
    path: "login",
    element: <Suspense 
    fallback={<LazyLoader />}>
    <LoginPage />
  </Suspense>,
  },
  {
    path: "forgot-password",
    element: <Suspense 
    fallback={<LazyLoader />}>
    <ForgotPassword />
  </Suspense>,
  },
  {
    path: "sign-up",
    element: <Suspense fallback={<LazyLoader />}>
    <SignUpPage />
  </Suspense>,
  },
  {
    path: "/",
    element:
      role == "admin" ? (
        <Navigate to="admin-layout" />
      ) : (
        <Navigate to="layout" />
      ),
  },
  {
    path: "my-profile/edit",
    element: <Suspense fallback={<LazyLoader />}>
    <MyProfile />
  </Suspense>,
  },
  {
    path: "compare",
    element:<Suspense fallback={<LazyLoader />}>
    <CompareCars />
  </Suspense>,
  },
  {
    path: "brands",
    element:<Suspense fallback={<LazyLoader />}>
    <Brands />
  </Suspense>,
  },
 
  {
    path: "location",
    element:<Suspense fallback={<LazyLoader />}>
    <Location />
  </Suspense>,
  },
  {
    path: "upgrade-ad",
    element:<Suspense fallback={<LazyLoader />}>
    <UpgradeAd />
  </Suspense>,
  },
  {
    path: "payment-method",
    element: <Suspense fallback={<LazyLoader />}>
    <PaymentMethod />
  </Suspense>,
  },
  {
    path: "fill-form",
    element: <Suspense fallback={<LazyLoader />}>
    <PaymentForm />
  </Suspense>,
  },
  {
    path: "used-bikes",
    element: <Suspense fallback={<LazyLoader />}>
    <Bikes />
  </Suspense>,
  },
  {
    path: "new-bikes",
    element: <Suspense fallback={<LazyLoader />}>
    <Bikes />
  </Suspense>,
  },
  {
    path: "terms-and-policy",
    element: <Suspense fallback={<LazyLoader />}>
    <PrivacyPolicy />
  </Suspense>,
  },
  {
    path: "delete",
    element: (
      <Suspense fallback={<LazyLoader />}>
        <DeleteDataPage />
      </Suspense>
    ),
  },
  // {
  //   path: "login",
  //   element: <LogIn />,
  // },
  // {
  //   path: "sign-up",
  //   element: <SignUp />,
  // },
  {
    path: "layout",
    element: <MainLayout />
      ,
    children: [
      {
        path: "",
        element: <Navigate to="landing" replace />,
      },
      {
        path: "landing",
        element:
            <LandingPage />
         ,
      },
      {
        path: "sell",
        element: (
          <Suspense fallback={<LazyLoader />}>
            <SellCar />
          </Suspense>
        ),
      },

      {
        path: "ads",
        element: (
          <Suspense fallback={<LazyLoader />}>
            <Ads />
          </Suspense>
        ),
        children: [
          {
            path: "",
            element: <Navigate to="my-ads" />,
          },
          {
            path: "my-ads",
            element: (
              <Suspense fallback={<LazyLoader />}>
                <MyAds />
              </Suspense>
            ),
            children: [
              {
                path: "",
                element: <Navigate to="active" />,
              },
              {
                path: "Active",
                element: (
                  <Suspense fallback={<LazyLoader />}>
                    <Active />
                  </Suspense>
                ),
              },
              {
                path: "Pending",
                element: (
                  <Suspense fallback={<LazyLoader />}>
                    <Pending />
                  </Suspense>
                ),
              },
              {
                path: "Inactive",
                element: (
                  <Suspense fallback={<LazyLoader />}>
                    <InActive />
                  </Suspense>
                ),
              },
              {
                path: "Removed",
                element: (
                  <Suspense fallback={<LazyLoader />}>
                    <Removed />
                  </Suspense>
                ),
              },
            ],
          },
          {
            path: "my-saved-ads",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <SavedAds />
              </Suspense>
            ),
          },
          {
            path: "my-rides",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <MyRides />
              </Suspense>
            ),
          },
          {
            path: "my-alerts",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <MyAlerts />
              </Suspense>
            ),
          },
          {
            path: "messages",
            element: (
              <Suspense fallback={<LazyLoader />}>
                <Messages />
              </Suspense>
            ),
            children: [
              {
                path: "",
                element: <Navigate to="my-messages-user" replace />,
              },
              {
                path: "my-messages-user",
                element: (
                  <Suspense fallback={<LazyLoader />}>
                    <MyMessagesUser />
                  </Suspense>
                ),
              },
              {
                path: "chat",
                element: (
                  <Suspense fallback={<LazyLoader />}>
                    <Chat />
                  </Suspense>
                ),
              },
            ],
          },
          {
            path: "orders",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <MyOrders />
              </Suspense>
            ),
          },
          {
            path: "payment",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <Payment />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "admin-layout",
    element:(
      <Suspense fallback={<LazyLoader />}>
        <AdminLayout />
      </Suspense>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="users" replace />,
      },
      {
        path: "users",
        element:
        (
      <Suspense fallback={<LazyLoader />}>
        <Index />
      </Suspense>
    ),
        children: [
          {
            path: "",
            element: <Navigate to="users" replace />,
          },
          {
            path: "users",
            element:  (
              <Suspense fallback={<LazyLoader />}>
                <Users />
              </Suspense>
            ),
          },
          {
            path: "user_details",
            element: (
              <Suspense fallback={<LazyLoader />}>
                <UserDetails />
              </Suspense>
            ),
          },
          // {
          //   path: "user_details",
          //   element: <UserDetails />,
          // },
          {
            path: "Active",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <ActivePosts />
              </Suspense>
            ),
          },
          {
            path: "inActive",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <InActivePosts />
              </Suspense>
            ),
          },
          {
            path: "Pending",
            element:(
              <Suspense fallback={<LazyLoader />}>
                <PendingPosts />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "list",
        element:(
          <Suspense fallback={<LazyLoader />}>
            <List />
          </Suspense>
        ),
        children: [
          {
            path: "",
            element: <Navigate to="make" replace />,
          },
          {
            path: "make",
          element:(
            <Suspense fallback={<LazyLoader />}>
              <Make />
            </Suspense>
          ),
          },
          {
            path: "model",
          element:(
            <Suspense fallback={<LazyLoader />}>
              <Model />
            </Suspense>
          ),
          },
          {
            path: "version",
          element:(
            <Suspense fallback={<LazyLoader />}>
              <Version />
            </Suspense>
          ),
          },
        ]
      },
     
    ],
  },
  {
    path: "car-listing",
    
    element:(
      <Suspense fallback={<LazyLoader />}>
    <FindYourCar />
  </Suspense>
    ),
  },
  {
    path: "single-brand-category",
    element:(
      <Suspense fallback={<LazyLoader />}>
    <SingleBrandCategory />
  </Suspense>
    ),
  },
  {
    path: "brand-category",
    element: (
      <Suspense fallback={<LazyLoader />}>
    <BrandCategory />
  </Suspense>),
  },
  {
    path: "car-details/:id",
    element:(
      <Suspense fallback={<LazyLoader />}>
    <CarDetails />
  </Suspense>),
  },

  //   {
  //     path: "home",
  //     element: <Home />,
  //     children: [
  //       {
  //         path: "",
  //         element: <Navigate to="details" replace />,
  //       },
  //       {
  //         path: "details",
  //         element: <Details />,
  //       },
  //       {
  //         path: "options",
  //         element: <Options />,
  //       },
  //       {
  //         path: "persona-overview",
  //         element: <PersonaOverview />,
  //       },
  //       {
  //         path: "insights",
  //         element: <Insights />,
  //       },
  //       {
  //         path: "sustainabilty-IT",
  //         element: <SustainabiltyIT />,
  //       },
  //     ],
  //   },
]);

export default router;
